import React from 'react';
import { Link } from 'react-router-dom';
import './RelatedEvents.css';

function RelatedEvents({ events = [] }) {
  if (events.length === 0) return null;

  return (
    <div className="related-events">
      <h3>Altri eventi in programma</h3>
      <div className="related-grid">
        {events.map(event => {
          const [day, month, year] = event.date.split('/').map(Number);
          const dateObj = new Date(year, month - 1, day);
          return (
            <Link 
              key={event.id} 
              to={`/events/${event.id}`} 
              className="related-event-card"
            >
              <div className="related-event-date">
                <span className="date-day">{dateObj.getDate()}</span>
                <span className="date-month">
                  {dateObj.toLocaleDateString('it-IT', { month: 'short' })}
                </span>
              </div>
              <div className="related-event-info">
                <h4>{event.title}</h4>
                <p className="related-location">📍 {event.location || event.place}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default RelatedEvents;
